import React from "react";
import "./priceItem2.scss";
const PriceItem2 = ({ left, right }) => {
  return (
    <div className="price-item2">
      <div className="left">{left}</div>
      <div className="right">{right}</div>
    </div>
  );
};

export default PriceItem2;
